import { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
const faqs = [{
  q: "¿Cómo recibiré el material?",
  a: "Inmediatamente después de completar tu compra recibirás un correo con acceso a toda la biblioteca digital para descargarla desde cualquier dispositivo."
}, {
  q: "¿Los archivos son descargables?",
  a: "Sí. Todo el contenido se entrega en formato PDF de alta calidad para que puedas consultarlo cuando lo necesites."
}, {
  q: "¿Es un pago único?",
  a: "Sí. No existen mensualidades ni renovaciones automáticas. Compras una sola vez y el acceso es para siempre."
}, {
  q: "¿Sirve para cualquier software de alineadores?",
  a: "Sí. Los principios clínicos, protocolos y sistemas de decisión pueden aplicarse independientemente de la plataforma digital que utilices."
}, {
  q: "¿Está dirigido solo a ortodoncistas?",
  a: "No. También está pensado para odontólogos generales que desean incorporar alineadores con mayor seguridad y predictibilidad."
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-slate-50 py-14 sm:py-20" data-id="element-76" data-mp="fiytu4rn8c8h">
      <div className="mx-auto max-w-lg px-5 sm:max-w-2xl" data-id="element-77" data-mp="kibovcso4pm5">
        <SectionHeading eyebrow="FAQ" title="Preguntas Frecuentes" data-id="element-78" data-mp="kkxv993toz2s" />

        <div className="mt-8 space-y-3" data-id="element-79" data-mp="6qog4dhjhomh">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-80" data-mp="bjzpomdqkji3" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-81" data-mp="1teu77tczv3e">
                  <span className="font-head text-sm font-700 text-[#0f2547] sm:text-base" data-id="element-82" data-mp="3o1o3lumvno7n">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#1e88e5] transition-transform ${isOpen ? "rotate-180" : ""}`} data-id="element-83" data-mp="1ppuq4s78xvol" />
                </button>
                <AnimatePresence initial={false} data-id="element-84" data-mp="1ftrp5po4s338">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-85" data-mp="2dee0redrqkju">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-slate-600" data-id="element-86" data-mp="1zew5cg5yw91i">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}